import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Document } from 'src/app/beans/health-record/other-documents.bean';

@Injectable({
	providedIn: 'root',
})
export class ListDocumentService {
	documents: BehaviorSubject<Document[]>;

	constructor() {
		this.documents = new BehaviorSubject<any>([]);
	}

	setDocuments(input) {
		this.documents.next(input);
	}

	getDocuments(): BehaviorSubject<Document[]> {
		return this.documents;
	}
}
